import React from "react";
import Privacypolicy from "../../Components/Privcypolicy/Privacypolicy.jsx";
import Termcond from "../../Components/Terms&cond/Term&cond.jsx";
import Contact from "../../Components/Contact/Contact.jsx";
import About from "../../Components/AboutUs/About.jsx";
// import Category from "../../Components/Category/Category.jsx";
import Myprofile from "../../Components/Myprofile/Myprofile.jsx";
import Myorder from "../../Components/Myorder/Myorder.jsx";
import Cart from "../../Components/Cart/Cart.jsx";
import Myaddress from "../../Components/My-address/My-address.jsx";
import Address from "../../Components/Address/Address.jsx";
import Ewishlist from "../../Components/Empty-wishlist/Empty-wishlist.jsx";
import Wishlist from "../../Components/Wishlist/wishlist.jsx";
import Blog from "../../Components/Blog/Blog.jsx";
import Mywishlist from "../../Components/My-wishlist/Mywishlist.jsx";
import Checkout from "../../Components/Checkout/Checkout.jsx";
import Blogdetails from "../../Components/Blogdetails/Blogdetails.jsx";
import Refunds from "../../Components/Refunds/Refunds.jsx";
import { Route, Routes } from "react-router-dom";
import Products from "../../Components/Products/Products.jsx";
import Payment from "../../Components/Payment/Payment.jsx";
import Productdetails from "../../Components/Productdetails/Productdetails.jsx";
import Register from "../../Components/Register/Register.jsx";
import Home from "../../Components/Home/Home.jsx";
import Login from '../../Components/Login/Login.jsx';
import Thanks from "../Thanks/Thanks.jsx";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/Home" element={<Home />} />

      <Route path="/privacy-policy" element={<Privacypolicy />} />
      <Route path="/Termcond" element={<Termcond />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/products" element={<Products/>}/>
      <Route path="/Termcond" element={<Termcond />} />
      <Route path="/Blog" element={<Blog />} />
      <Route path="/Cart" element={<Cart />} />
      <Route path="/Checkout" element={<Checkout />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/About" element={<About />} />
      {/* <Route path="/Category" element={<Category />} /> */}
      <Route path="/Refunds" element={<Refunds />} />
      {/* <Route path="/Category" element={<Category />} /> */}
      <Route path="/Myprofile" element={<Myprofile />} />
      <Route path="/Myorder" element={<Myorder />} />
      <Route path="/Myaddress" element={<Myaddress />} />
      <Route path="/Address" element={<Address />} />
      <Route path="/Productdetails" element={<Productdetails />} />
      <Route path="/Ewishlist" element={<Ewishlist />} />
      <Route path="/Wishlist" element={<Wishlist />} />
      <Route path="/Mywishlist" element={<Mywishlist />} />
      <Route path="/Payment" element={<Payment />} />
      <Route path="/Register" element={<Register />} />
      <Route path="/Blogdetails" element={<Blogdetails />} />
      <Route path="/login" element={<Login/>}/>
      <Route path="/Thanks" element={<Thanks/>}/>
    </Routes>
  );
};

export default AppRouter;
